interface FundMetricsProps {
  fundSize?: string;
  managementFee?: number;
  performanceFee?: number;
  inceptionDate?: string;
}

export function FundMetrics({ 
  fundSize, 
  managementFee, 
  performanceFee, 
  inceptionDate 
}: FundMetricsProps) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 w-full">
      <div className="space-y-1.5 min-w-0">
        <p className="text-sm text-muted-foreground">Fund Size</p>
        <p className="font-medium break-words">{fundSize || 'N/A'}</p>
      </div>
      <div className="space-y-1.5 min-w-0">
        <p className="text-sm text-muted-foreground">Management Fee</p>
        <p className="font-medium break-words">
          {managementFee ? `${managementFee}%` : 'N/A'}
        </p>
      </div>
      <div className="space-y-1.5 min-w-0">
        <p className="text-sm text-muted-foreground">Performance Fee</p>
        <p className="font-medium break-words">
          {performanceFee ? `${performanceFee}%` : 'N/A'}
        </p>
      </div>
      <div className="space-y-1.5 min-w-0">
        <p className="text-sm text-muted-foreground">Inception Date</p>
        <p className="font-medium break-words">
          {inceptionDate ? new Date(inceptionDate).toLocaleDateString() : 'N/A'}
        </p>
      </div>
    </div>
  );
}